"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndCallButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../../context/room_session");
const use_media_breakpoint_1 = require("../../../../hooks/use_media_breakpoint");
function EndCallButton({ host, onClicked = () => { } }) {
    const theme = (0, ui_react_1.useTheme)();
    const roomSession = (0, room_session_1.useRoomSession)();
    const [leavingRoom, setLeavingRoom] = (0, react_1.useState)(false);
    const [confirmLeave, setConfirmLeave] = (0, react_1.useState)(false);
    const { isSmallScreen } = (0, use_media_breakpoint_1.useMediaBreakpoint)();
    const leaveRoom = () => __awaiter(this, void 0, void 0, function* () {
        if (leavingRoom) {
            return;
        }
        else {
            setLeavingRoom(true);
            yield roomSession.leaveRoom();
        }
    });
    const handleConfirmLeave = (value) => {
        setConfirmLeave(value);
    };
    const isEmbed = !host && isSmallScreen;
    const isEV = !host && !isSmallScreen;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(isEmbed || host) && ((0, jsx_runtime_1.jsx)(LeaveCallConfirmationTooltip, Object.assign({ confirmLeave: confirmLeave, setConfirmLeave: handleConfirmLeave, host: host, leavingRoom: leavingRoom, leaveRoom: leaveRoom, onClicked: onClicked }, { children: confirmLeave ? ((0, jsx_runtime_1.jsx)(CancelIconButton, { setConfirmLeave: handleConfirmLeave, theme: theme })) : ((0, jsx_runtime_1.jsx)(EndCallIconButton, { confirmLeave: confirmLeave, setConfirmLeave: handleConfirmLeave, host: host, leavingRoom: leavingRoom, isSmallScreen: isSmallScreen, theme: theme })) }))), isEV && ((0, jsx_runtime_1.jsx)(LeaveCallConfirmationTooltip, Object.assign({ confirmLeave: confirmLeave, setConfirmLeave: handleConfirmLeave, host: host, leavingRoom: leavingRoom, leaveRoom: leaveRoom, onClicked: onClicked }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ "data-testid": 'end-call-button', onClick: () => setConfirmLeave(!confirmLeave), variant: confirmLeave ? 'tertiary' : 'danger', disabled: leavingRoom, style: { minWidth: '127px' } }, { children: confirmLeave ? 'Cancel' : 'Leave' })) })))] }));
}
exports.EndCallButton = EndCallButton;
const EndCallIconButton = ({ confirmLeave, setConfirmLeave, host, leavingRoom, isSmallScreen, theme, }) => {
    const handleEndCall = () => {
        if (!confirmLeave) {
            setConfirmLeave(true);
        }
    };
    return ((0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { iconName: "PhoneIconFilled", label: "End Call Button", "data-testid": "end-call-button", onClick: handleEndCall, color: theme.colors.red50, fill: theme.colors.white, background: "red50", size: host ? 'CVLarge' : 'medium', iconSize: host ? '30px' : '20px', disabled: leavingRoom, style: {
            marginLeft: isSmallScreen ? '8px' : '0px',
            marginRight: isSmallScreen ? '8px' : '0px',
        } }));
};
const CancelIconButton = ({ setConfirmLeave, theme }) => ((0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { iconName: "CloseIcon", label: "Cancel", "data-testid": "cancel-button", onClick: () => setConfirmLeave(false), fill: theme.colors.blue50, background: "blue05", style: {
        marginLeft: '8px',
        marginRight: '8px',
        zIndex: 3,
        position: 'relative',
    } }));
const LeaveCallConfirmationTooltip = ({ children, confirmLeave, setConfirmLeave, host, leavingRoom, leaveRoom, onClicked, }) => {
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Sensor, Object.assign({ onClickOutside: () => setConfirmLeave(false), onEscape: () => setConfirmLeave(false) }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ showTooltip: confirmLeave, placement: "top", arrowSize: "0px", color: "grey80", offsetValue: 15, opacity: "0.9", padding: host ? '29vh 16px 16px 16px' : '16px', width: host ? '100vw' : '', height: host ? '100vh' : '' }, (host && { position: 'fixed' }), (host && { inset: '0' }), (host && { transform: 'none' }), { message: (0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ "data-testid": 'confirm-end-call-button', onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    yield leaveRoom();
                    onClicked();
                }), variant: "danger", disabled: leavingRoom, style: host
                    ? {
                        margin: '0 auto',
                        width: '85%',
                    }
                    : {} }, { children: "Leave Call" })), isModal: true }, { children: children })) })));
};
//# sourceMappingURL=end_call_button.js.map